import React, { Component } from 'react';
import {Button, DatePicker, Form, Input, Select} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
const { Option } = Select;

class CCEmail extends Component{
    render() {
        return <div>
            <Form.Item
                label="Sold To"
                name={'soldToNumber'}
                rules={[{ required: true}]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="PO Number"
                name={'poNumber'}
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Part Number"
                name={'partNumber'}
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Quantity"
                name={'quantity'}
                rules={[{ required: true }]}
            >
                <Input onChange={this.props.onCreditAmountTotal} />
            </Form.Item>
            <Form.Item
                label="Price Drop Date"
                name={'priceDropDate'}
                rules={[{ required: true}]}
            >
                <DatePicker />
            </Form.Item>
            <Form.Item
                label="Unit Dispute Value"
                name={'creditAmountUnit'}
                rules={[{ required: true}]}
            >
                <Input onChange={this.props.onCreditAmountTotal} />
            </Form.Item>
            <Form.Item
                label="Dispute Value Total"
                name={'creditAmountTotal'}
                rules={[{ required: true}]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Currency"
                name={'currency'}
                rules={[{ required: true}]}
            >
                <Select placeholder={'Please select'}>
                    {
                        this.props.currencyList.map((item)=>{
                            return <Option value={item.key} >{item.value}</Option>
                        })
                    }
                </Select>
            </Form.Item>
            <Form.List name="template1">
                {(fields, { add, remove }) => (
                    <>
                        <Form.Item
                            className={'addFormBtn'}
                            label="Claim Details"
                        >
                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                            </Button>
                        </Form.Item>
                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                            <div>
                                <Form.Item
                                    label="Sold To"
                                    {...restField}
                                    name={[name, 'soldToNumber']}
                                    fieldKey={[fieldKey, 'soldToNumber']}
                                    rules={[{ required: true}]}
                                >
                                    <Input suffix={<div>
                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                    </div>}/>
                                </Form.Item>
                                <Form.Item
                                    label="PO Number"
                                    {...restField}
                                    name={[name, 'poNumber']}
                                    fieldKey={[fieldKey, 'poNumber']}
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Part Number"
                                    {...restField}
                                    name={[name, 'partNumber']}
                                    fieldKey={[fieldKey, 'partNumber']}
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Quantity"
                                    {...restField}
                                    name={[name, 'quantity']}
                                    fieldKey={[fieldKey, 'quantity']}
                                    rules={[{ required: true }]}
                                    onChange={(e)=>{
                                        this.props.onCreditAmountTotal(e,name)
                                    }}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Price Drop Date"
                                    {...restField}
                                    name={[name, 'priceDropDate']}
                                    fieldKey={[fieldKey, 'priceDropDate']}
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker />
                                </Form.Item>
                                <Form.Item
                                    label="Unit Dispute Value"
                                    {...restField}
                                    name={[name, 'creditAmountUnit']}
                                    fieldKey={[fieldKey, 'creditAmountUnit']}
                                    rules={[{ required: true }]}
                                    onChange={(e)=>{
                                        this.props.onCreditAmountTotal(e,name)
                                    }}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Dispute Value Total"
                                    {...restField}
                                    name={[name, 'creditAmountTotal']}
                                    fieldKey={[fieldKey, 'creditAmountTotal']}
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Currency"
                                    {...restField}
                                    name={[name, 'currency']}
                                    fieldKey={[fieldKey, 'currency']}
                                    rules={[{ required: true }]}
                                >
                                    <Select placeholder='Please select'>
                                        {
                                            this.props.currencyList.map((item)=>{
                                                return <Option value={item.key} >{item.value}</Option>
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        ))}
                    </>
                )}
            </Form.List>
        </div>
    }
}

export default CCEmail;